import { render } from "./CarouselWrap.vue?vue&type=template&id=857a4bb4"
import script from "./CarouselWrap.vue?vue&type=script&lang=js"
export * from "./CarouselWrap.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__